var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Pill, PillCheckGroupBase } from '../PillCheckGroupBase';
/**
 * Renders a group of 'pill checkboxes'.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */
export function PillCheckGroup(props) {
    const { ariaLabel, enforceSingleValue, disableGroup, label, onChangeHandler, pills, values, verticalOrientation, } = props;
    return (React.createElement(PillCheckGroupBase, { "aria-label": ariaLabel, className: "PillCheckGroup", enforceSingleValue: enforceSingleValue, "data-testid": props['data-testid'], disableGroup: disableGroup, label: label, values: values, onChange: (incomingValues) => onChangeHandler(incomingValues), verticalOrientation: verticalOrientation }, pills.map((pill) => {
        const { id, pillText, value } = pill, rest = __rest(pill, ["id", "pillText", "value"]);
        return (React.createElement(Pill, Object.assign({ id: id, key: id, "data-cy": pill['data-cy'], "data-testid": pill['data-testid'], isSelected: values.includes(value), value: value }, rest), pillText));
    })));
}
//# sourceMappingURL=PillCheckGroup.js.map